export const fullCircleDeg = 360;
export const halfCircleDeg = 180;
